 <div class="sidebar-header">
   <div style="color: #c2cfd6; font-weight: normal; ">{{""}}</div>
   <!--<img class="logo-full.sidebar-header" src="assets/img/logo-full.png" />-->
 </div>
